// ABOUTME: The 5D THIS CROSSING card: the five readings as real text, the guiding truth, and the storm's child line.
// ABOUTME: On phone it is visually hidden but stays in the accessible tree, so the readings are never lost.

import { useId } from 'react';
import { Box } from '@mui/material';
import {
  CROSSING_GOLD_INK,
  CROSSING_SUMMARY_CARD_BORDER,
  CROSSING_SUMMARY_CARD_GROUND,
  CROSSING_SUMMARY_CARD_SHADOW,
  CROSSING_SUMMARY_CHILD_INK,
  CROSSING_SUMMARY_DIVIDER,
  CROSSING_SUMMARY_LABEL_INK,
  CROSSING_SUMMARY_ROW_INK,
  CROSSING_SUMMARY_TRUTH_LABEL,
} from '../../../../theme/crossingTokens';
import { visuallyHidden } from '../../runner/visuallyHidden';
import type { Summary } from './summaryModel';

const EYEBROW_STYLE = { fontSize: '10px', fontWeight: 900, letterSpacing: '2px' } as const;

// The scene drives the card's arrival and leaving through these.
export interface CardBeat {
  opacity: number;
  transform: string;
  transition: string;
}

interface SummaryCardProps {
  summary: Summary;
  hidden: boolean;
  beat?: CardBeat;
}

export function SummaryCard({ summary, hidden, beat }: SummaryCardProps) {
  const eyebrowId = useId();
  return (
    <Box
      component="section"
      aria-labelledby={eyebrowId}
      data-testid="summary-card"
      sx={{
        position: 'absolute', left: 682, top: 176, width: 338, height: 372, boxSizing: 'border-box',
        display: 'flex', flexDirection: 'column', gap: '14px', padding: '22px 24px', borderRadius: '16px', zIndex: 8, ...beat,
        background: CROSSING_SUMMARY_CARD_GROUND, border: `1px solid ${CROSSING_SUMMARY_CARD_BORDER}`, boxShadow: CROSSING_SUMMARY_CARD_SHADOW,
        ...(hidden ? visuallyHidden : {}),
      }}
    >
      <Box id={eyebrowId} sx={{ ...EYEBROW_STYLE, color: CROSSING_GOLD_INK }}>THIS CROSSING</Box>
      <Box component="dl" sx={{ margin: 0, display: 'grid', gridTemplateColumns: 'auto 1fr', columnGap: '14px', rowGap: '8px', fontSize: '13px', lineHeight: 1.35 }}>
        {summary.rows.map(row => (
          <Box key={row.label} sx={{ display: 'contents' }}>
            <Box component="dt" sx={{ fontWeight: 800, color: CROSSING_SUMMARY_LABEL_INK }}>{row.label}</Box>
            <Box component="dd" sx={{ margin: 0, color: CROSSING_SUMMARY_ROW_INK }}>{row.value}</Box>
          </Box>
        ))}
      </Box>
      <Box component="hr" sx={{ border: 0, margin: 0, height: '1px', background: CROSSING_SUMMARY_DIVIDER }} />
      <Box sx={{ ...EYEBROW_STYLE, color: CROSSING_SUMMARY_TRUTH_LABEL }}>★ GUIDING TRUTH</Box>
      <Box sx={{ fontFamily: 'Newsreader, serif', fontWeight: 500, fontSize: '21px', lineHeight: 1.3, color: CROSSING_SUMMARY_LABEL_INK, textWrap: 'pretty' }}>
        {summary.truth}
      </Box>
      {summary.childLine && (
        <Box sx={{ fontSize: '13px', lineHeight: 1.45, color: CROSSING_SUMMARY_CHILD_INK }}>{summary.childLine}</Box>
      )}
    </Box>
  );
}
